import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './index.css';
import './styles/utilities.css';
import App from './App';

// CREATE React root for application mounting
const root = ReactDOM.createRoot(document.getElementById('root'));

// RENDER application with router support
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);